// extracted by mini-css-extract-plugin
module.exports = {"container":"policy-benefits-module__container___IFFZC","benefitsContainer":"policy-benefits-module__benefitsContainer___Q6P7R","tier":"policy-benefits-module__tier___ybOCA"};